/**
 * Development (hosted) environment. Swapped in for `environment.ts` by the
 * `development` build configuration in `angular.json`.
 *
 * Hosts are {app}.{tier}.sisoma.dev. Dev is served by the `halio-api-dev` App
 * Platform app, which runs the current `dev` build of the API.
 * See users/environment.dev.ts.
 */
export const environment = {
  production: false,
  apiUrl: 'https://api.dev.sisoma.dev',
  loginUrl: 'https://app.dev.sisoma.dev/login',
  // Root of the legacy `users` app — the "Back to Halio" footer link opens it.
  usersAppUrl: 'https://app.dev.sisoma.dev',
};
